<template>
      <div class="fill-height">
        <v-card class="fill-height">
          <v-card-title  class="p-1">
            <v-chip
                label    small
                class="ma-2"
                color="secondary">
              پروفایل
            </v-chip>
            <v-spacer/>
            <v-btn light icon @click="$router.push('/home')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>

            <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
              <v-row>
                              <v-col
                                  cols="12"
                                  sm="6"
                                  md="4">
                                <v-text-field
                                    label="نام شخص"
                                    outlined
                                    dense
                                    disabled
                                    v-model="model.fullName"
                                />
                              </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4">
                  <v-text-field
                      label="نام کاربری"
                      outlined
                      dense
                      disabled
                      v-model="model.userName"
                  />
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4">

                  <v-text-field
                      label="کلمه عبور قبلی"
                      outlined
                      dense
                      :error-messages="getError('currentPass')"
                      v-model="model.currentPass"
                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4">

                  <v-text-field
                      label="کلمه عبور جدید"
                      outlined
                      type="number"
                      dense
                      :error-messages="getError('newPass')"
                      v-model="model.newPass"
                  />

                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4">

                  <v-text-field
                      label="تکرار کلمه عبور جدید"
                      outlined
                      dense
                      type="number"
                      :error-messages="getError('rePass')"
                      v-model="model.rePass"
                  />


                </v-col>



              </v-row>


              <v-divider class="p-0 m-0"/>
              <v-card-actions dir="ltr">

                <v-btn
                    small
                    depressed
                    color="primary"
                    class=" pr-5 pl-5"
                    type="submit"
                >
                  ذخیره
                </v-btn>
              </v-card-actions>
            </v-form>

          </v-card-text>
        </v-card>
      </div>

</template>

<script>
import Profile_se from "./Profile_se";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
  },
  data() {
    return {
      // dialogStatus:true,
      model:{},
      bindingErrors: [],
      valid: true,

    }
  },




  methods: {

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      this.$router.push("/login")
    },

    save(){
      this.bindingErrors = []
        Profile_se.changePass(this.model).then(response => {
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
              this.closed()
          }else if (response && response.response.status === 400) {
            this.bindingErrors = response.response.data;
          }
        })

    },
    getUser(){
      Profile_se.getUser().then(response => {
        this.model=response.data
      })

    }

  },
created() {
    this.getUser()
}


}
</script>
<style>
@import "../../../assets/styles/global.css";
</style>

